import { requestWithToken } from '../utilities/request';

const path = '/api/private/';

// api :GET, '/api/private/machines/list', '機械分類取得API'
// description '鹿島CO2用機械分類マスタの取得'
// param: base_id 親ID
// return: {id（machine_id）, name, code}を配列
const getMachinesList = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('machines/list'),
    params: param,
  });
};

// api :GET, '/api/private/machine_specs/list', '機械仕様取得API'
// description '鹿島CO2用機械仕様の取得'
// param: machine_id 機械ID
// return: {id(machine_spec_id), name, code, power, fuel_rate}を配列
const getMachineSpecsList = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('machine_specs/list'),
    params: param,
  });
};

// api :GET, '/api/private/machine_fuels/list', '機械燃料取得API'
const getMachineFuelsList = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat('machine_fuels/list'),
    params: param,
  });
};

export const FieldMasters = {
  getMachinesList,
  getMachineSpecsList,
  getMachineFuelsList,
};

export default FieldMasters;



// WEBPACK FOOTER //
// ./src/services/FieldMasters.js